// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7174":"65d93d9e","9324":"c48c9fff"}[chunkId] + ".chunk.css";
};